module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/7GHiEJ0msgMhVzGdmoWNvH-d01475028477af7686662975410da189.jpg";